<template lang="pug">
.layout
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4
        v-btn(icon small @click='showModal = false')
          v-icon(size="22" color="primary") mdi-close
        div.h6.basic800--text.ml-4 {{ $t('filters') }}
        v-spacer
        v-btn(color='white', text @click="resetFilter")
          .button-Aa-small.primary400--text {{ $t('reset') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="applyFilter" dark)
          .button-AA-small.basic100--text {{ $t('done') }}
      v-divider.basic300
      v-card-text.pa-0
        .sort
          payout-sort.pa-6(:parentSort.sync="sort")
          v-divider.basic300

        .date
          payout-date.pa-6(:parentRange.sync="range")
          v-divider.basic300

        .tier-level
          payout-tier.pa-6(:parentTier.sync="tier" :companyTiers="companyTiers")
          v-divider.basic300

</template>

<script>
import PayoutSort from '@/components/resellers/payouts/PayoutSort.vue'
import PayoutDate from '@/components/resellers/payouts/PayoutDate.vue'
import PayoutTier from '@/components/resellers/payouts/PayoutTier.vue'

export default {
  name: 'PayoutFilter',
  components: { PayoutSort, PayoutDate, PayoutTier },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      required: true
    },
    companyTiers: {
      type: Array,
      required: true
    },
  },
  data: () => ({
    sort: null,
    range: {},
    tier: null
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  created () {
    this.checkFilter()
  },
  methods: {
    checkFilter () {
      this.sort = this.filters.sort || 'newest',
      this.range = this.filters.range || { name: 'All', value: null, date: null }
      this.tier = this.filters.tier
    },
    resetFilter () {
      this.sort = 'newest'
      this.range = {
        name: 'All',
        value: null,
        date: null
      }
      this.tier = null
    },
    applyFilter () {
      const filters = {
        sort: this.sort,
        range: this.range,
        tier: this.tier,
      }
      this.$emit('updateFilter', filters)
      this.showModal = false
    }
  }
}
</script>
